export var screens = {
  miniPhone: 300,
  phone: 500,
  phablet: 640,
  tablet: 800,
  miniDesktop: 1024,
  desktop: 1200,
  bigScreen: 1300,
  hugeScreen: 1500
};